import { DEFAULT_IFRAME_URL } from 'site-modules/canvas/constants/canvas';
import { addQueryParam, removeQueryParam } from 'site-modules/shared/utils/url-utils';

const QUERY_PARAM = {
  CANVAS_REF: 'canvas_ref',
  REF: 'ref',
};

const REF_VALUE = 'canvas';

export function getInitialIframeSrc(queryPage, referrer) {
  return addQueryParam(decodeURIComponent(queryPage || '/'), QUERY_PARAM.CANVAS_REF, referrer);
}

export function getIframeUrl(iframeRef) {
  const iframeWindow = iframeRef?.current?.contentWindow;
  return `${iframeWindow?.location?.pathname}${iframeWindow?.location?.search}`;
}

export function getNewPageCanvasUrl(canvasPathname, iframeRef) {
  const iframeUrl = removeQueryParam(
    removeQueryParam(getIframeUrl(iframeRef), QUERY_PARAM.REF, REF_VALUE),
    QUERY_PARAM.CANVAS_REF
  );

  return iframeUrl === DEFAULT_IFRAME_URL ? canvasPathname : addQueryParam(canvasPathname, 'page', iframeUrl);
}

export function addCanvasLinkRef(href) {
  return addQueryParam(href, QUERY_PARAM.REF, REF_VALUE);
}
